<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { getAnalyticsTracker } from '@/tracking/analytics/plugin'
import { toolkitUrls } from '@/util/links'
import { getBlogPosts, type BlogPost } from './api'
import { FROM_HOME, HOME_EVENT_NAMES } from './event_names'
import { TRAINING_CENTER_HEADING_CLASSES, TRAINING_CENTER_LINK_CLASSES } from './training_center_styles'
import TrainingCenterLoadingNotice from './TrainingCenterLoadingNotice.vue'

const analytics = getAnalyticsTracker()
const posts = ref<BlogPost[]>([])
const isLoading = ref(true)

async function loadPosts() {
  try {
    posts.value = await getBlogPosts()
  } catch (error) {
    console.error(error)
  } finally {
    isLoading.value = false
  }
}

function trackPostClick(post: BlogPost, index: number) {
  analytics.sendEvent(HOME_EVENT_NAMES.CLICKED_POST_LINK, {
    ...FROM_HOME,
    title: post.fields.title,
    URL: post.fields.url,
    position: index + 1
  })
}

function trackViewAllPosts() {
  analytics.sendEvent(HOME_EVENT_NAMES.CLICKED_VIEW_ALL_POSTS, FROM_HOME)
}

onMounted(loadPosts)
</script>

<template>
  <div class="ml-4">
    <h3 :class="TRAINING_CENTER_HEADING_CLASSES" class="mt-[40px] md:max-xl:mt-0">Recent Updates</h3>
    <TrainingCenterLoadingNotice v-if="isLoading">Loading recent updates...</TrainingCenterLoadingNotice>
    <ul class="mb-[10px] list-none p-0">
      <li v-for="(post, index) in posts" :key="post.id" class="mb-4 text-[1rem]" data-testid="blog-post">
        <a
          :href="post.fields.url"
          :class="TRAINING_CENTER_LINK_CLASSES"
          rel="noopener"
          target="_blank"
          @click="trackPostClick(post, index)"
        >
          <span class="sr-only">Blog post:</span>
          {{ post.fields.title }}
          <span class="sr-only">(opens in a new tab)</span>
        </a>
      </li>
    </ul>
    <a
      :href="toolkitUrls.toolkitUpdates"
      :class="TRAINING_CENTER_LINK_CLASSES"
      target="_blank"
      rel="noopener"
      data-testid="view-all-updates"
      @click="trackViewAllPosts"
    >
      View all updates
      <span class="sr-only">(opens in a new tab)</span>
    </a>
  </div>
</template>
